import React, { useState } from "react";
import { useParams } from "react-router-dom";

const ExamSchedule = () => {
  const { regulation } = useParams();
  const [selectedSchedule, setSelectedSchedule] = useState("cie2");

  // Replace with actual Google Drive file IDs
  const pdfLinks = {
    "2019": {
      cie1: "",
      cie2: "",
      cie3: "",
      sem: "1GTaceSHZBUOej5kE4iioZYnnwUDePZan",  
      cie1retest : "",
      cie2retest : "",
      cie3retest : "",
    },
    "2023": {
      cie1: "13Q8cP7zkw7YN6Z8k6k9JQTqwo9EqiREW",
      cie2: "15Jb4PNnL_71r3NpdE68OrZMb1_JK9y9x",
      cie3: "1wcKCNKr8MkM5SegpCBkX91Lzu0QEERYd",
      sem: "1ItKm0bMevJMjKGI67nJPFqxYmyQtU8_s",
      cie1retest : "",
      cie2retest : "",
      cie3retest : "",
    },
  };
  const fileId = pdfLinks?.[regulation]?.[selectedSchedule];

  return (
    <div className="min-h-screen bg-cover bg-center bg-no-repeat flex flex-col items-center justify-center">
      <div className="bg-grey bg-opacity-80 rounded-lg shadow-lg max-w-5xl w-full text-center p-4">
        <h1 className="text-2xl font-bold mb-4 text-white-800"> <br />
          {regulation} Regulation - Exam Schedule [Current Semester]
        </h1>

        {/* Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-6">
          <button
            onClick={() => setSelectedSchedule("cie1")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "cie1"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            CIE 1
          </button>
          <button
            onClick={() => setSelectedSchedule("cie2")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "cie2"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            CIE 2
          </button>
          <button
            onClick={() => setSelectedSchedule("cie3")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "cie3"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            CIE 3
          </button>
          <button
            onClick={() => setSelectedSchedule("sem")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "sem"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            Semester 
          </button>
          {/* <button
            onClick={() => setSelectedSchedule("cie1retest")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "cie1retest"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            CIE 1 Retest 
          </button>
          <button
            onClick={() => setSelectedSchedule("cie2retest")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "cie2retest"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            CIE 2 Retest 
          </button>
          <button
            onClick={() => setSelectedSchedule("cie3retest")}
            className={`px-4 py-2 rounded-md font-medium transition ${
              selectedSchedule === "cie3retest"
                ? "bg-blue-600 text-white"
                : "bg-white border border-blue-600 text-blue-600"
            }`}
          >
            CIE 3 Retest 
          </button> */}
        </div>

        {/* Iframe Preview */}
        {fileId ? (
          <div className="w-full aspect-video">
            <iframe
              title={`Exam Schedule ${regulation}`}
              src={`https://drive.google.com/file/d/${fileId}/preview`}
              width="100%"
              height="500"
              allow="autoplay"
              className="rounded-lg shadow-lg"
            ></iframe>
          </div>
        ) : (
          <p className="text-white-600 font-bold">
            Current Semester Data will be updated soon
          </p>
        )}

      </div>
    </div>
  );
};

  // const pdfLinks = {
  //   "2019": {
  //     cie1: "1Vsv7nqoOGXvwI_68xTifqFEh_SfFBOjS",
  //     cie2: "1TvhUKpk8ltN_4hy50z8f4F55p9YXxvli",
  //     cie3: "1QhqcsWmj1p0EWZpzPa8L2WglUoFu28UP",
  //     sem: "1kEdXlxQ3v2tN4dIVYQ1E58Lz56hu71lY",
  //   },
  //   "2023": {
  //     cie1: "YOUR_CIE3_FILE_ID_FOR_2023",
  //     cie2: "YOUR_CIE3_FILE_ID_FOR_2023",
  //     cie3: "YOUR_CIE3_FILE_ID_FOR_2023",
  //     sem: "1HWhG_P-qRww3iYIplLBb1MRtwzaFYLVc",
  //   },
  // };

export default ExamSchedule;
